import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { useState } from 'react'
import { Menu, Search, X } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Logo } from '@/components/generals/logo'
import { HeaderSearch } from '@/components/generals/header-search'
import { NotificationsMenu, ProfileMenu } from '@/components/generals/header-menus'
import { ConfluenceHint } from '@/components/generals/confluence-hint'
import { HintsMenu } from '@/components/generals/hints-toggle'

interface HeaderProps {
    onOpenMenu: () => void
}

export const Header: FC<HeaderProps> = ({ onOpenMenu }): ReactNode => {
    const [mobileSearch, setMobileSearch] = useState(false)

    return (
        <header className='sticky top-0 z-40 border-b border-border bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/85'>
            <div className='flex h-16 items-center gap-2 px-3 sm:gap-3 sm:px-4 lg:px-6'>
                <button
                    type='button'
                    onClick={onOpenMenu}
                    className='flex size-10 cursor-pointer items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-secondary hover:text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/45 lg:hidden'
                    aria-label='باز کردن منوی اصلی'
                >
                    <Menu className='size-5' aria-hidden='true' />
                </button>

                <Link
                    href='/'
                    className='shrink-0 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/45 lg:w-[232px]'
                    aria-label='مدیریت دانش بهسازان ملت، صفحه اصلی'
                >
                    <Logo />
                </Link>

                <div className='relative mx-auto hidden w-full max-w-2xl flex-1 md:block'>
                    <HeaderSearch shortcut />
                    <ConfluenceHint id='header-search' className='-top-2.5' />
                </div>

                <div className='ms-auto flex items-center gap-1 md:ms-0'>
                    <button
                        type='button'
                        onClick={() => setMobileSearch(value => !value)}
                        aria-expanded={mobileSearch}
                        className='flex size-10 cursor-pointer items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-secondary hover:text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/45 md:hidden'
                        aria-label={mobileSearch ? 'بستن جست‌وجو' : 'جست‌وجوی دانش'}
                    >
                        {mobileSearch ? <X className='size-5' aria-hidden='true' /> : <Search className='size-5' aria-hidden='true' />}
                    </button>

                    <HintsMenu />
                    <NotificationsMenu />
                    <ProfileMenu />
                </div>
            </div>

            <div className={cn('border-t border-border px-3 py-2.5 md:hidden', !mobileSearch && 'hidden')}>
                {mobileSearch && <HeaderSearch autoFocus onNavigate={() => setMobileSearch(false)} />}
            </div>
        </header>
    )
}
